export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00690.b85b97f2.png";